<div class="inbox-datatable__main-content scrollable-component">
	<div class="inbox-filter__content mb-0">
		<div class="filter">
			<cv-input
				[label]="'Transaction'"
				[type]="'search'"
				[placeholder]="'Transaction ID'"
				[value]="filterOrders.transactionId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('transactionId', $event)"
				(controlKeyup)="onFiltersChange('transactionId', $event)"
			>
			</cv-input>
		</div>
		<div class="filter">
			<cv-dropdown
				[label]="'Provider'"
				[placeholder]="'Select a provider'"
				[selectedValue]="providerSelected"
				[clearSelection]="clearProviderSelected"
				[options]="providerList"
				(valuesChange)="onProviderSelected($event)"
			>
			</cv-dropdown>
		</div>
		<div class="filter">
			<cv-input
				[label]="'Provider ID'"
				[type]="'search'"
				[placeholder]="'Provider ID'"
				[value]="filterOrders.providerId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('providerId', $event)"
				(controlKeyup)="onFiltersChange('providerId', $event)"
			>
			</cv-input>
		</div>
		<div class="filter" *ngIf="filterOrders.provider === 'xpanse'">
			<cv-input
				[label]="'Xpanse Loan Number'"
				[type]="'search'"
				[placeholder]="'Xpanse Loan Number'"
				[value]="filterOrders.xpanseLoanNumber"
				[maxlength]="100"
				(textCleared)="onFiltersChange('xpanseLoanNumber', $event)"
				(controlKeyup)="onFiltersChange('xpanseLoanNumber', $event)">
			</cv-input>
		</div>
		<div class="filter_add">
			<div class="filter_addendum">
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="filterOrders.isAddendum"
					[size]="'sm'"
					(valueChange)="onAddendumFilterChange($event)"
				>
				</cv-switch>
				<span>Is Addendum</span>
			</div>
		</div>
		<div class="filter_search">
			<span class="width-space"></span>
		</div>
	</div>
	<div class="inbox-filter__content mb-1">
		<div class="filter">
			<cv-input
				[label]="'Acuity Id'"
				[type]="'search'"
				[placeholder]="'Acuity ID'"
				[value]="filterOrders.acuityId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('acuityId', $event)"
				(controlKeyup)="onFiltersChange('acuityId', $event)"
			>
			</cv-input>
		</div>
		<div class="filter">
			<cv-input
				[label]="'AppScope File #'"
				[type]="'search'"
				[value]="filterOrders.filenumber"
				[placeholder]="'AppScope File #'"
				[maxlength]="100"
				(textCleared)="onFiltersChange('filenumber', $event)"
				(controlKeyup)="onFiltersChange('filenumber', $event)"
			>
			</cv-input>
		</div>
		<div class="filter">
			<cv-input
				[label]="'Class Order Id'"
				[type]="'search'"
				[value]="filterOrders.orderId"
				[placeholder]="'Class Order ID'"
				[maxlength]="100"
				(textCleared)="onFiltersChange('orderId', $event)"
				(controlKeyup)="onFiltersChange('orderId', $event)"
			>
			</cv-input>
		</div>
		<div class="filter_search">
			<button class="btn btn-sm cv-btn-blue" (click)="loadGridData()">
				<i class="fas fa-search"></i>
			</button>
		</div>
	</div>
	<div class="mb-3">
		<button class="btn-link btn btn-sm" (click)="clearAllFilters()">
			<i class="fa fa-trash mr-1"></i>
			clear filters
		</button>
	</div>
	<div class="datatable-content scrollable-component">
		<ag-grid-angular
			#grid
			class="ag-theme-balham configurable-grid"
			[style.height.px]="gridHeight"
			[enableCellTextSelection]="false"
			(gridReady)="onInitializeGrid($event)"
			(gridSizeChanged)="resizeToFitColumns()"
			[pagination]="false"
			[suppressPaginationPanel]="true"
			[rowClassRules]="rowClassRules"
			[gridOptions]="gridOptions"
			[domLayout]="'normal'"
			[rowData]="gridData"
			[getRowHeight]="getRowHeight"
		>
		</ag-grid-angular>

		<div class="filter-input text-right">
			<cv-input
				[displayMode]="'inline'"
				[label]="'Limit'"
				[placeholder]="'Limit'"
				[type]="'number'"
				[value]="filterOrders.limit"
				[maxlength]="2"
				[min]="0"
				(controlChange)="onFiltersChange('limit', $event)"
				(controlKeyup)="onFiltersChange('limit', $event)"
			>
			</cv-input>
		</div>
	</div>
</div>
